import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

interface StepType {
  stepUrl: string;
  stepMessage: string;
  stepranking: number;
  bot: "happy" | "mad";
}

interface GuiderType {
  ranking: number;
  step: StepType;
}

const lostStep: StepType = {
  stepranking: 0,
  stepUrl: "",
  bot: "happy",
  stepMessage: "Are you lost! You can go to the home and I'll guid you then.",
};

const defaultGuider: GuiderType = {
  ranking: 0,
  step: {
    stepranking: 0,
    stepUrl: "",
    bot: "mad",
    stepMessage:
      "it seems like you don't want my help, well assume the consequences",
  },
};

export const useGuider = (mode: boolean | undefined) => {
  const steps: StepType[] = [
    {
      stepranking: 1,
      stepUrl: "/",
      bot: "happy",
      stepMessage: `Welcome to my humble website.\nAs you can see behind me the home page nothing that important there please checkout the ABOUT page.\nThe button on the menu with the ${
        mode ? "darker" : "lighter"
      } background will take you there`,
    },
    {
      stepranking: 2,
      stepUrl: "/about",
      bot: "happy",
      stepMessage: `Well, you're in the ABOUT page you will find here some information about me,\n and about my carrer with some of my skills and technologies I work with.\nAfter checking the ABOUT page. please consider visiting my PORTFOLIO.\nThe button on the menu with the ${
        mode ? "darker" : "lighter"
      } background will take you there`,
    },
    {
      stepranking: 3,
      stepUrl: "/portfolio",
      bot: "happy",
      stepMessage: `This is my PORTFOLIO page here you will find some of my project.\n Take a look at some of them who knows you may find something interesting`,
    },
  ];

  const [guider, setGuider] = useState<GuiderType>(defaultGuider);
  const [open, setOpen] = useState<boolean>(true);

  let location = useLocation();

  useEffect(() => {
    try {
      if (localStorage.getItem("guider")) {
        setGuider(JSON.parse(localStorage.getItem("guider") ?? ""));
        steps.forEach((item) => {
          if (item.stepUrl === location.pathname) {
            if (item.stepranking === guider.ranking + 1)
              setGuider({ ...guider, step: item, ranking: item.stepranking });
            else {
              if (guider.ranking === 0)
                setGuider({ ...guider, step: lostStep });
              else setGuider({ ...guider, step: defaultGuider.step });
            }
            if (guider.ranking < steps.length) setOpen(true);
            return;
          }
        });
      } else {
        if (location.pathname === "/")
          setGuider({
            ranking: 1,
            step: steps.flatMap((item) =>
              item.stepUrl === "/" ? item : []
            )[0],
          });
        else setGuider({ ...defaultGuider, step: lostStep });
      }
      localStorage.setItem("guider", JSON.stringify(guider));
    } catch (error) {
      localStorage.setItem(
        "guider",
        JSON.stringify({ ...defaultGuider, step: lostStep })
      );
    }
  }, [location.pathname]);

  return { guider, open, setOpen };
};
